import React from 'react';
import ReactDOM from 'react-dom';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../lang/main';
import PrintButton from './common/PrintButton';
import ReactTableWrapper from './ReactTableWrapper';
import TrackingNumber from './common/TrackingNumber';
import { axiosRequestOrder } from '../actions/orderActions';
import { convertOrderDetailToAReadableFormat } from '../selectors/converterSelector';
import ReactLoading from 'react-loading';
import PrintPackingLabelButton from './common/PrintPackingLabelButton';
import { handleAxiosErrors, __currencyDisplay } from '../_utils';

const modalRoot = document.getElementById('modal-root');

class OrderViewModal extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            data: {},
        };

        this.mainTableWrapper = null;
        this.constructMainElement();
    }
    constructMainElement() {
        const { modalKey } = this.props;

        this.el = document.createElement('div');
        this.el.setAttribute('id', modalKey);
        this.el.setAttribute('role', 'dialog');
        this.el.setAttribute('class', 'modal modal--small fade');
    }
    componentDidMount() {
        this._isMounted = true;

        modalRoot.appendChild(this.el);
        this.request();
    }
    componentWillUnmount() {
        this._isMounted = false;

        modalRoot.removeChild(this.el);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.id != this.props.id) {
            const timeoutDelay = this._isMounted ? 0 : 150;
            setTimeout(() => {
                this.request();
            }, timeoutDelay);
        }
    }
    toggleLoading(value) {
        this.setState({
            isLoading: value,
        });
    }
    request() {
        const { updateListParamsCallback, id } = this.props;

        if (typeof id == 'undefined' || id <= 0) {
            return null;
        }

        let listParams = {
            filters: {
                ID: id,
            },
        };

        if (
            typeof updateListParamsCallback != 'undefined' &&
            updateListParamsCallback
        ) {
            listParams = updateListParamsCallback(listParams);
        }

        this.toggleLoading(true);

        axiosRequestOrder(listParams)
            .then((response) => {
                const data = convertOrderDetailToAReadableFormat(
                    response.data.data.readCartOrders
                );

                this.setState({
                    data: data,
                    isLoading: false,
                });
            })
            .catch((error) => {
                handleAxiosErrors(error);
                this.toggleLoading(false);
            });
    }
    getTableProps() {
        const tableProps = {
            list: {
                // noDataText: <span>No items found. <br/>See results from our full range below.</span>,
                columns: [
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading hidden-xs'>
                                        <LocalizedMessage id={'PRODUCT_CODE'} />
                                    </span>
                                    <span className='react-table__heading visible-xs'>
                                        <LocalizedMessage id={'CODE'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'hidden-xs',
                        className: 'hidden-xs',
                        minWidth: 80,
                        accessor: 'InternalItemID',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading hidden-xs'>
                                        <LocalizedMessage id={'PRODUCT_NAME'} />
                                    </span>
                                    <span className='react-table__heading visible-xs'>
                                        <LocalizedMessage id={'NAME'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            const { InternalItemID } = row.original;
                            return (
                                <React.Fragment>
                                    <div className='react-table__info'>
                                        <span className='product__code visible-xs'>
                                            {InternalItemID}
                                        </span>
                                        <div className='product__general-title'>
                                            {row.value}
                                        </div>
                                    </div>
                                </React.Fragment>
                            );
                        },
                        minWidth: 150,
                        accessor: 'Title',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading hidden-xs'>
                                        <LocalizedMessage id={'QUANTITY'} />
                                    </span>
                                    <span className='react-table__heading visible-xs'>
                                        <LocalizedMessage id={'QTY'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'tx-center',
                        className: 'tx-center',
                        minWidth: 70,
                        accessor: 'TotalUnitItems',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'COST'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {__currencyDisplay(row.value)}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'tx-right',
                        className: 'tx-right',
                        minWidth: 80,
                        accessor: 'UnitPrice',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'TOTAL'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {__currencyDisplay(row.value)}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'tx-right',
                        className: 'tx-right',
                        minWidth: 80,
                        accessor: 'TotalPrice',
                    },
                ],
                showPagination: false,
                getTrGroupProps: (state, row, col, instance) => {
                    const { viewIndex } = row;

                    const isExpanded =
                        state.expanded &&
                        state.expanded.hasOwnProperty(viewIndex) &&
                        state.expanded[viewIndex];
                    let classes = 'react-table__row';
                    classes += ` ${
                        isExpanded ? 'react-table__row--expanded' : ''
                    }`;

                    return {
                        className: classes,
                    };
                },
            },
        };

        return tableProps;
    }
    render() {
        const { data, isLoading } = this.state;
        const { memberType } = this.props;
        const {
            ID,
            InternalItemID,
            PaymentMethodNice,
            PlacedNice,
            FirstName,
            Surname,
            BillingAddress,
            ShippingAddress,
            Status,
            ShippingStatus,
            Items,
            Total,
            TaxTotal,
            DiscountTotal,
            ShippingTotal,
        } = data;

        return ReactDOM.createPortal(
            <div className='modal__center'>
                {isLoading ? (
                    <ReactLoading
                        className='button__spinner'
                        type='spin'
                        color='white'
                        height={40}
                        width={40}
                    />
                ) : (
                    <div className='modal-dialog modal__helper'>
                        <div
                            className='modal__container'
                            style={{ maxWidth: 990 }}
                        >
                            <div className='modal__header'>
                                <span
                                    className='modal__close'
                                    data-dismiss='modal'
                                    title='Close'
                                >
                                    <i className='icon icon-close' />
                                </span>
                                <h2 className='heading heading--lv2'>
                                    <LocalizedMessage id={'ORDER_SUMMARY'} />
                                </h2>
                            </div>
                            <div className='modal__content'>
                                <div className='order-summary'>
                                    <div className='row'>
                                        <div className='col-xs-12 col-md-6 vspace vspace--small'>
                                            <div className='order-summary__item'>
                                                <span className='order-summary__label'>
                                                    <LocalizedMessage
                                                        id={'ORDER_NUMBER'}
                                                    />
                                                </span>
                                                <span className='order-summary__value'>
                                                    {InternalItemID || '-'}
                                                </span>
                                            </div>
                                            <div className='order-summary__item'>
                                                <span className='order-summary__label'>
                                                    <LocalizedMessage
                                                        id={'DATE'}
                                                    />
                                                </span>
                                                <span className='order-summary__value'>
                                                    {PlacedNice || '-'}
                                                </span>
                                            </div>
                                            <div className='order-summary__item'>
                                                <span className='order-summary__label'>
                                                    <LocalizedMessage
                                                        id={'PAYMENT_METHOD'}
                                                    />
                                                </span>
                                                <span className='order-summary__value'>
                                                    {PaymentMethodNice || '-'}
                                                </span>
                                            </div>
                                            <div className='order-summary__item'>
                                                <span className='order-summary__label'>
                                                    <LocalizedMessage
                                                        id={'ORDER_STATUS'}
                                                    />
                                                </span>
                                                <span className='order-summary__value'>
                                                    {Status || '-'}
                                                </span>
                                            </div>
                                            <div className='order-summary__item'>
                                                <span className='order-summary__label'>
                                                    <LocalizedMessage
                                                        id={'SHIPPING_STATUS'}
                                                    />
                                                </span>
                                                <span className='order-summary__value'>
                                                    {ShippingStatus || '-'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-md-6 vspace vspace--small'>
                                            <div className='order-summary__item'>
                                                <span className='order-summary__label'>
                                                    <LocalizedMessage
                                                        id={'NAME'}
                                                    />
                                                </span>
                                                <span className='order-summary__value'>
                                                    {FirstName} {Surname}
                                                </span>
                                            </div>
                                            <div className='order-summary__item'>
                                                <span className='order-summary__label'>
                                                    <LocalizedMessage
                                                        id={'BILLING_ADDRESS'}
                                                    />
                                                </span>
                                                <span className='order-summary__value'>
                                                    {BillingAddress || '-'}
                                                </span>
                                            </div>
                                            <div className='order-summary__item'>
                                                <span className='order-summary__label'>
                                                    <LocalizedMessage
                                                        id={'SHIPPING_ADDRESS'}
                                                    />
                                                </span>
                                                <span className='order-summary__value'>
                                                    {ShippingAddress || '-'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Order Items */}
                                <div className='vspace'>
                                    <ReactTableWrapper
                                        loading={false}
                                        data={Items || []}
                                        reactTable={this.getTableProps()}
                                        ref={(r) => (this.mainTableWrapper = r)}
                                    />
                                    <div className='data-table__footer'>
                                        <div
                                            className='data-table__tr'
                                            role='row'
                                        >
                                            <div className='data-table__td'>
                                                <span className='data-table__footer-info'>
                                                    <LocalizedMessage id={'FIELD.FREIGHT_DELIVERY_OPTION'} />
                                                </span>
                                            </div>
                                            <div className='data-table__td tx-right'>
                                                <span className='data-table__footer-info'>
                                                    {__currencyDisplay(ShippingTotal)}
                                                </span>
                                            </div>
                                        </div>

                                        {DiscountTotal > 0 && (
                                            <div
                                                className='data-table__tr'
                                                role='row'
                                            >
                                                <div className='data-table__td'>
                                                    <span className='data-table__footer-info'>
                                                        <LocalizedMessage id={'DISCOUNT'} />
                                                    </span>
                                                </div>
                                                <div className='data-table__td tx-right'>
                                                    <span
                                                        className='data-table__footer-info'
                                                        style={{ color: 'red' }}
                                                    >
                                                        -{__currencyDisplay(DiscountTotal)}
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        <div
                                            className='data-table__tr'
                                            role='row'
                                        >
                                            <div className='data-table__td'>
                                                <span className='data-table__footer-info'>
                                                    <LocalizedMessage id={'TAX'} />
                                                </span>
                                            </div>
                                            <div className='data-table__td tx-right'>
                                                <span className='data-table__footer-info'>
                                                    {__currencyDisplay(TaxTotal)}
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className='data-table__tr'
                                            role='row'
                                        >
                                            <div className='data-table__td'>
                                                <span className='data-table__sum'>
                                                    <LocalizedMessage id={'TOTAL'} />
                                                </span>
                                            </div>
                                            <div className='data-table__td tx-right'>
                                                <span className='data-table__sum'>
                                                    {__currencyDisplay(Total)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-xs-4 col-sm-6'>
                                        <PrintButton />
                                    </div>
                                    <div className='col-xs-8 col-sm-6 tx-right'>
                                        {/* TODO */}
                                        {memberType == 'wholesaler' && (
                                            <PrintPackingLabelButton
                                                url={window.location.href}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>,
            this.el
        );
    }
}

export default OrderViewModal;
